import { render, staticRenderFns } from "./customer-grant-form.vue?vue&type=template&id=4cf895e3&"
import script from "./customer-grant-form.vue?vue&type=script&lang=js&"
export * from "./customer-grant-form.vue?vue&type=script&lang=js&"
import style0 from "./customer-grant-form.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports